export default __webpack_public_path__ + "Meredith Murray.97a593ff6c0b2e313a73.png";